import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import env from '@app/environment'

// Initialize PostHog once, outside of React
if (typeof window !== 'undefined') {
  const getPostHogBootstrap = () => {
    const params = new URLSearchParams(window.location.search)
    const distinctID = params.get('vbph_did')
    const sessionID = params.get('vbph_sid')
    return (distinctID && sessionID) ? { distinctID, sessionID } : null
  }

  const bootstrap = getPostHogBootstrap()

  posthog.init(env.PUBLIC_POSTHOG_KEY, {
    api_host: env.PUBLIC_POSTHOG_HOST,
    save_campaign_params: true,
    persistence: 'localStorage+cookie',
    capture_pageleave: true,
    capture_pageview: true,
    // Automatically catch unhandled JS errors and promise rejections.
    // Can also be toggled from PostHog → Settings → Error tracking.
    capture_exceptions: true,
    ...(bootstrap && { bootstrap }),
  })

  // Tag every event (including anonymous ones) with the tenant/client domain.
  // This runs before React renders so even the first pageview is grouped.
  // When the user logs in, posthogIdentify() calls group() again with the
  // same key — PostHog merges properties, nothing is lost.
  posthog.group('tenant', window.location.hostname, {
    domain: window.location.hostname,
  })
}

export function PHProvider({ children }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>
}